import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { LeaderCriteriaResponse } from "~pages/LeaderCriteria/types/leaderCriteria.ts";
import type { CreateLeaderCriteriaModel } from "~pages/LeaderCriteria/types/leaderCriteriaModel.ts";

export const useCreateLeaderCriteria = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<LeaderCriteriaResponse, Error, CreateLeaderCriteriaModel>({
    mutationFn: async (body) =>
      await request<LeaderCriteriaResponse>(`${sport}/o/${organizationId}/statistics/leaders/criteria`, {
        method: "POST",
        body,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["leaderCriteria", sport, organizationId] });
    },
  });
};
